import './chart_view.js.coffee';# Added by Script 
import './ticket_count_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.RecontactMetricChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/recontact_metric_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'recontact_metric'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.recontact_metric.title')
    description = I18n.t('customer_visual_mode.charts.recontact_metric.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_ticketCountCardViews().forEach (view) =>
      @$('.recontact-metric-chart').append(
        view.render().el
      )
    @

  _ticketCountCardViews: ->
    [
      @_recontactPercentageView()
    ]

  _recontactPercentageView: ->
    @newTicketsView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'recontact_rate'
      count: @data.percentage || 0
      precision: 2
      unit: '%'
      statusClass: 'recontact-rate'
      clickable: false
      title: I18n.t('customer_visual_mode.charts.recontact_metric.title')
    )
